// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoaderChart_wrapper__E21a0"};